import { MetadataEntry } from '../../types/MetadataEntry';
import { ModalPortalShell } from '../ui/ModalPortalShell';
import { MetadataEditor } from './MetadataEditor';

type JsonMetadataModalProps = {
  open: boolean;
  title: string;
  description?: string;
  entries: MetadataEntry[];
  disabled?: boolean;
  onChange: (entries: MetadataEntry[]) => void;
  onClose: () => void;
};

export function JsonMetadataModal({
  open,
  title,
  description,
  entries,
  disabled = false,
  onChange,
  onClose,
}: JsonMetadataModalProps) {
  return (
    <ModalPortalShell
      open={open}
      panelClassName="erp-card max-w-3xl shadow-xl"
      overlayClassName="z-50"
    >
      <div className="shrink-0 border-b border-secondary-100 px-5 py-4">
        <h2 id="json-metadata-modal-title" className="erp-card-title">
          {title}
        </h2>
        {description ? <p className="erp-card-subtitle mt-1">{description}</p> : null}
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-5 py-4">
        <MetadataEditor entries={entries} disabled={disabled} onChange={onChange} />
      </div>

      <div className="erp-btn-actions shrink-0 border-t border-secondary-100 px-5 py-4">
        <button type="button" className="erp-btn-primary" onClick={onClose}>
          Concluir
        </button>
      </div>
    </ModalPortalShell>
  );
}
